import{lazy as o}from"react";const r=o((()=>import("./AudioIcon.js")));export{r as AudioIcon};
